import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/ssl/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import Show from 'components/utils/Show';

const OffshoreTrainee = props => {
    const {schema, initialValues} = bootstrapOldForm(
        'Offshore Trainee',
        fields
    );
    const [BCOTrainee, setBCOTrainee] = useFieldData();
    const [BSTrainee, setBSTrainee] = useFieldData();
    const showBCOTrainee = BCOTrainee === true || BCOTrainee === 'true';
    const showBSTrainee = BSTrainee === true || BSTrainee === 'true';

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Offshore Trainee Days
            </Typography>
            <AutoField
                field={fields.bco_trainee}
                name='bco_trainee'
                onChange={e => setBCOTrainee(e.target.value === 'true')}
            />
            <Show condition={showBCOTrainee}>
                <AutoField
                    field={fields.bco_under_supervision_days}
                    name='bco_under_supervision_days'
                />
            </Show>
            <AutoField
                field={fields.bco_trainee}
                name='bs_trainee'
                onChange={e => setBSTrainee(e.target.value === 'true')}
            />
            <Show condition={showBSTrainee}>
                <AutoField
                    field={fields.bco_under_supervision_days}
                    name='barge_supervisor_under_supervision_days'
                />
            </Show>
            {props.children}
        </Section>
    );
};

export default OffshoreTrainee;
